// export const base_url = "http://localhost:5000/"
// export const base_url = "http://51.20.125.209:5000/"
// export const base_url = "http://16.171.241.112:5000/"
// export const base_url = "http://13.51.64.99:5000/"
// export const base_url = "http://16.170.215.79:5000/"
// export const base_url = "https://blitz.lappu.vip/"
export const base_url = "https://patakha.lappu.vip/"
// export const base_url = "http://192.168.1.8:9207/"
export const common_chart_url = "https://resultapi.org/"

